module.exports = __webpack_public_path__ + "static/uottawa_branch_logo-1-b83b30debea017e4d942303d534ec58e.png";